module.exports = __webpack_public_path__ + "img/container-7.fc54c448.png";